import { initIdVerifySdk } from './idVerifySdk';

/**
 * @namespace "actions.tickets"
 */

// the following is imported in actions/index.js as "tickets"
export default {
  initIdVerifySdk
};
